import React from 'react';
import KYCContainer from 'containers/onboarding/KYCContainer';

/**
 * KYC Page - Know Your Customer verification
 * @component
 * @returns {React.ReactElement} KYCPage
 */
const KYCPage = () => {
  return (
    <KYCContainer />
  );
};

export default KYCPage;
